import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { InformesRxService } from 'src/app/services/transacciones/informes-rx.service';

export class LanguageApp {
  public static spanish_datatables = {
    processing: 'Procesando...',
    search: 'Buscar:',
    lengthMenu: 'Mostrar _MENU_ registros',
    info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
    infoEmpty: 'Mostrando ningún elemento.',
    infoFiltered: '(filtrado _MAX_ elementos total)',
    infoPostFix: '',
    loadingRecords: 'Cargando registros...',
    zeroRecords: 'No se encontraron registros',
    emptyTable: 'No hay datos disponibles en la tabla',
    paginate: { first: 'Primero', previous: 'Ant', next: 'Sig', last: 'Último' },
    aria: {
      sortAscending: ': Activar para ordenar la tabla en orden ascendente',
      sortDescending: ': Activar para ordenar la tabla en orden descendente'
    }
  };
}

@Component({
    selector: 'app-informes-rx',
    templateUrl: './informes-rx.component.html',
    styleUrls: ['./informes-rx.component.scss'],
    standalone: false
})
export class InformesRxComponent implements OnInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  public informes: any[] = [];
  public cargando = false;
  private tablaInicializada = false;

  constructor(
    private informesRxService: InformesRxService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.dtOptions = {
      language: LanguageApp.spanish_datatables,
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true,
      order: [[6, 'desc']]
    };
    this.cargarPendientes();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  cargarPendientes(): void {
    this.cargando = true;
    const token = localStorage.getItem('token') || '';

    this.informesRxService.listarPendientes(token).subscribe({
      next: (resp: any) => {
        this.cargando = false;
        this.informes = resp?.rows || [];

        if (this.tablaInicializada) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.tablaInicializada = false;
            setTimeout(() => {
              this.dtTrigger.next(null);
              this.tablaInicializada = true;
            });
          });
        } else {
          setTimeout(() => {
            this.dtTrigger.next(null);
            this.tablaInicializada = true;
          });
        }
      },
      error: () => {
        this.cargando = false;
        this.toastr.error('No se pudieron cargar los informes pendientes');
      }
    });
  }

  abrirInforme(informe: any): void {
    this.router.navigate(['/sistema/subir-informe-rx', this.makeid(100) + informe.id + this.makeid(100)]);
  }

  private makeid(length: number): string {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) result += chars.charAt(Math.floor(Math.random() * chars.length));
    return result;
  }
}
